import React from "react";
import { getFitmentData } from "./fetcher";
import {ACTIONS} from "./reducer";

export default function DeckSizeSelect(props) { 
    const {state, dispatch } = props
    const { deckSizes, deckSize } = state

    React.useEffect(() => {
        if (deckSizes.length === 1) {
            dispatch({type: ACTIONS.SET_DECK_SIZE, payload: deckSizes[0].value})
        }
    },[deckSizes, dispatch])

    React.useEffect(() => {
        async function getConfigurations(selectedDeckSize) {
            //will return an deckSize list
            const configurations = await getFitmentData({
                calltype: 6,
                equipmentCategory: state.category,
                manufacturer: state.manufacturer,
                model: state.model,
                modelType: state.modelType,
                deckSize: selectedDeckSize,
            })
            dispatch({type: ACTIONS.SET_CONFIGURATIONS, payload: configurations});
        }
        if (deckSize) {
            getConfigurations(deckSize)
        }
    }, [deckSize, dispatch, state.category, state.manufacturer, state.model, state.modelType])

    async function handleChange(e) {
        dispatch({type: ACTIONS.SET_DECK_SIZE, payload: e.target.value})
    }
    
    return (
        <>
            <select id="sel_deckSize" required onChange={handleChange} value={deckSize} disabled={deckSizes.length === 0}>
                <option value="">Choose</option>
                {deckSizes.map((deckSize, index) => (
                    <option key={`DeckSize-${index}`} value={deckSize.value}>{deckSize.label}</option>
                ))}
            </select>
            <label htmlFor="sel_deckSize">Deck Size:</label>
        </>
    )
}

